import React from "react";

import Language from "./Language";
import HeaderSearch from "./HeaderSearch";
import Notificationbar from "./Notificationbar";
import AddBtnHeader from "./AddBtnHeader";
import RemindersHeader from "./Reminders";
import FullScreenToggle from "./FullScreenToggle";
import styles from "./index.module.scss";

// Header sağ blok. Yapı KASITEN düz/semantik: tek <ul class="nav-menus">,
// child'ları DOĞRUDAN <li> (ara sarıcı YOK). Cuba/Header CSS'i
// `.nav-right > ul > li` ile hedeflediği için li'ler ul'in direkt child'ı
// OLMAK ZORUNDA — aksi halde header dağılır (eski <UL>+<M display:contents>
// kurgusu ds-list <div> üretip bu zinciri kırıyordu).
//
// Mobilde gizlenecek ikinci-öncelik ikonlar `header-mobile-hide` class'ını
// kendi <li>'lerine alır (Header.scss ≤767.98px'te display:none verir).
const RightHeader = () => {
  return (
    <div className={`nav-right pull-right right-header ${styles.colWrap}`}>
      <ul className={`simple-list nav-menus ${styles.navList}`}>
        <Language className="header-mobile-hide" />
        <FullScreenToggle className="header-mobile-hide" />
        <RemindersHeader className="header-mobile-hide" />
        <HeaderSearch className="header-mobile-hide" />

        <AddBtnHeader />
        <Notificationbar />
      </ul>
    </div>
  );
};

export default RightHeader;
